import { client } from 'core/http';
import store from 'core/Store/Store';

export default function useServicesExport() {
  const { token } = store.getState().auth;
  const { baseURL } = client().defaults;

  const searchParams = new URLSearchParams({ token: token || '' });

  return baseURL + `services/export?${searchParams}`;
}
